import React from 'react'
import { Box, ToggleButtonGroup, ToggleButton } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { ViewMode } from '../types'

interface ViewModeToggleProps {
  viewMode: ViewMode
  onChange: (newMode: ViewMode) => void
}

const ViewModeToggle: React.FC<ViewModeToggleProps> = ({ viewMode, onChange }) => {
  const { t } = useTranslation()

  const handleViewModeChange = (event: React.MouseEvent<HTMLElement>, newMode: ViewMode) => {
    if (newMode !== null) {
      onChange(newMode)
    }
  }

  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', pb: 4 }}>
      <ToggleButtonGroup
        value={viewMode}
        exclusive
        onChange={handleViewModeChange}
        size="small"
        sx={{
          '& .MuiToggleButton-root': {
            fontSize: 10,
            px: 2,
            py: 0.5,
            textTransform: 'none'
          }
        }}
      >
        <ToggleButton value="by_resource">
          {t('auth.history.view_mode.by_resource', 'Changement sur utilisateur')}
        </ToggleButton>
        <ToggleButton value="by_actor">
          {t('auth.history.view_mode.by_actor', 'Changement par utilisateur')}
        </ToggleButton>
      </ToggleButtonGroup>
    </Box>
  )
}

export default ViewModeToggle
